import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import nzcafemapad_url from '../../../img/nzcafemap_ad.jpg';

const useStyles = makeStyles((theme) => ({
    adLarge: {
        width: '100%',
        marginBottom: theme.spacing(3),
        borderRadius: '6px',
        overflow: 'hidden',
        boxShadow: '0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1)',
        backgroundColor: '#fff',
    },
    fullImage: {
        display: 'block',
        width: '100%',
        '& img': {
            width: '100%',
            height: 'auto',
            display: 'block',
            transition: 'transform 0.3s ease',
        },
        '&:hover img': {
            transform: 'scale(1.02)',
        },
    },
}));

const AdNZCafemap = () => {
    const classes = useStyles();

    return (
        <Box className={classes.adLarge}>
            <a
                href="https://www.nzcafemap.com/"
                className={classes.fullImage}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={nzcafemapad_url} alt="NZ Cafe Map Advertisement" />
            </a>
        </Box>
    );
};

export default AdNZCafemap;
